var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
/**
 * This component is to be deprecated!
 * Please use "Tabs" instead
 */
import { useState } from 'react';
import MuiMenuItem from '@mui/material/MenuItem';
import MuiBox from '@mui/material/Box';
import MuiTabs from '@mui/material/Tabs';
import MuiTabContext from '@mui/lab/TabContext';
import Tab, { LabelWithBadge } from './Tab';
import TabPanel from './TabPanel';
import Typography from '../Typography';
import colors from '../../colors';
import { Popover } from '@mui/material';
import { ChevronDown, ChevronUp } from '../../icons';
var TabList = function (props) {
    var dropdown = props.dropdown, list = props.list, value = props.value, defaultValue = props.defaultValue, header = props.header, _a = props.headerVariant, headerVariant = _a === void 0 ? 'h3' : _a, onChange = props.onChange, restProps = __rest(props, ["dropdown", "list", "value", "defaultValue", "header", "headerVariant", "onChange"]);
    var _b = useState(defaultValue), innerValue = _b[0], setInnerValue = _b[1];
    var _value = value !== null && value !== void 0 ? value : innerValue;
    var handleChange = function (event, newValue) {
        if (_value !== undefined) {
            setInnerValue(newValue);
        }
        onChange && onChange(event, newValue);
    };
    return (_jsxs(MuiBox, { children: [header && (_jsx(MuiBox, __assign({ sx: { marginBottom: '12px' } }, { children: _jsx(Typography, __assign({ variant: headerVariant }, { children: header })) }))), _jsxs(MuiTabContext, __assign({ value: _value }, { children: [_jsxs(MuiTabs, __assign({}, restProps, { value: false, onChange: handleChange }, { children: [list.map(function (tabListItem, idx) { return (_jsx(Tab, __assign({ isActive: tabListItem.value === _value }, tabListItem), "tab_list_".concat(tabListItem.label).concat(idx))); }), dropdown && (_jsx(DropdownTab, { dropdown: dropdown, _value: _value, handleChange: handleChange }))] })), list.map(function (tabListItem, idx) { return (_jsx(TabPanel, __assign({ value: tabListItem.value, index: idx }, { children: tabListItem.content }), "tab_panel_".concat(tabListItem.label).concat(idx))); }), dropdown === null || dropdown === void 0 ? void 0 : dropdown.list.map(function (tabListItem, idx) { return (_jsx(TabPanel, __assign({ value: tabListItem.value, index: idx }, { children: tabListItem.content }), "tab_panel_".concat(tabListItem.label).concat(idx))); })] }))] }));
};
var DropdownTab = function (_a) {
    var dropdown = _a.dropdown, _value = _a._value, handleChange = _a.handleChange;
    var isDropdownItemActive = !!(dropdown === null || dropdown === void 0 ? void 0 : dropdown.list.map(function (item) { return item.value; }).includes(_value));
    var _b = useState(null), dropdownAnchorEl = _b[0], setDropdownAnchorEl = _b[1];
    var color = isDropdownItemActive || Boolean(dropdownAnchorEl) ? colors.blue[500] : colors.grey[800];
    return (_jsxs(MuiBox, __assign({ display: "flex", alignItems: "center" }, { children: [_jsx(Tab, { isActive: isDropdownItemActive, label: _jsxs(MuiBox, __assign({ sx: { display: 'flex', alignItems: 'center', gap: 1, height: '30px' } }, { children: [_jsx(Typography, __assign({ color: color, variant: 'body' }, { children: dropdown.title })), Boolean(dropdownAnchorEl) ? (_jsx(ChevronUp, { color: color })) : (_jsx(ChevronDown, { color: color }))] })), onClick: function (event) {
                    event.stopPropagation();
                    setDropdownAnchorEl(event.currentTarget);
                } }), _jsx(Popover, __assign({ onClose: function () { return setDropdownAnchorEl(null); }, anchorEl: dropdownAnchorEl, open: Boolean(dropdownAnchorEl), PaperProps: {
                    sx: {
                        boxShadow: '0px 2px 12px 0px color(display-p3 0 0 0 / 0.10)',
                        borderRadius: 1,
                        width: '250px',
                        mt: 1,
                    },
                }, anchorOrigin: {
                    vertical: 'bottom',
                    horizontal: 'left',
                }, transformOrigin: { horizontal: 'left', vertical: 'top' } }, { children: _jsx(MuiBox, __assign({ sx: {
                        p: 1,
                        '& .MuiButtonBase-root > div': { justifyContent: 'space-between', width: '100%' },
                    } }, { children: dropdown.list.map(function (tabListItem, idx) {
                        var _a;
                        return (_jsx(MuiMenuItem, __assign({ value: _value, onClick: function (event) {
                                event.stopPropagation();
                                handleChange(event, tabListItem.value);
                                setDropdownAnchorEl(null);
                            }, sx: { p: '8px 12px', borderRadius: 1, height: '40px' } }, { children: _jsx(LabelWithBadge, { label: tabListItem.label, badgeLabel: (_a = tabListItem.badgeLabel) !== null && _a !== void 0 ? _a : '0', isActive: tabListItem.value === _value }) }), "tab_list_".concat(tabListItem.label).concat(idx)));
                    }) })) }))] })));
};
export default TabList;
